import { render, staticRenderFns } from "./ProductBrochureDetail.vue?vue&type=template&id=5928aaae&scoped=true&"
import script from "./ProductBrochureDetail.vue?vue&type=script&lang=js&"
export * from "./ProductBrochureDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5928aaae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5928aaae')) {
      api.createRecord('5928aaae', component.options)
    } else {
      api.reload('5928aaae', component.options)
    }
    module.hot.accept("./ProductBrochureDetail.vue?vue&type=template&id=5928aaae&scoped=true&", function () {
      api.rerender('5928aaae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/operate/ProductBrochure/ProductBrochureDetail.vue"
export default component.exports